import { randomBox, tailwindColors, dark } from './style.css'

type RandomColorBoxProps = {
  children: React.ReactNode
  index: number
  active?: boolean
} & React.ComponentPropsWithoutRef<'div'>

export function RandomColorBox({ children, index, active = false, ...rest }: RandomColorBoxProps) {
  const color = active ? dark : tailwindColors[index % tailwindColors.length]
  return (
    <div
      className={randomBox}
      ref={(el) => {
        if (!el) return
        el.style.setProperty('--bg', color.bg)
        el.style.setProperty('--hover', color.hover)
        el.style.setProperty('--border', color.border)
        el.style.setProperty('--text', color.text)
      }}
      {...rest}
    >
      {children}
    </div>
  )
}
